/**
 * Filter the existing Dawn product gallery to the selected Color's images.
 * Does not replace MediaGallery, swipe, arrows, zoom, or variant logic.
 */
(function () {
  if (window.__gfColorGalleryInit) return;
  window.__gfColorGalleryInit = true;

  var HIDDEN = 'gf-color-gallery-hidden';
  var userSelectedColor = false;
  var lastColorKey = '';

  function norm(value) {
    return String(value || '')
      .trim()
      .toLowerCase();
  }

  function escapeRe(value) {
    return String(value).replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
  }

  function colorValueLabel(value) {
    if (value == null) return '';
    if (typeof value === 'string') return value;
    return value.name || value.label || String(value);
  }

  function readPayload(gallery) {
    var node = gallery.querySelector('[data-gf-color-gallery]');
    if (!node) return null;
    try {
      return JSON.parse(node.textContent);
    } catch (err) {
      return null;
    }
  }

  function uniqueIds(ids) {
    var seen = {};
    var out = [];
    (ids || []).forEach(function (id) {
      var key = String(id);
      if (!key || seen[key]) return;
      seen[key] = true;
      out.push(key);
    });
    return out;
  }

  function buildGroups(data) {
    var colors = (data.colorValues || []).map(colorValueLabel).filter(Boolean);
    if (colors.length < 2) return null;

    var groups = {};
    colors.forEach(function (color) {
      groups[norm(color)] = [];
    });

    var assigned = {};
    var featuredIndex = {};
    var altMatched = false;

    (data.variantMedia || []).forEach(function (entry) {
      var key = norm(colorValueLabel(entry.color));
      var id = entry && entry.id != null ? String(entry.id) : '';
      if (!key || !id || !groups[key] || assigned[id]) return;
      groups[key].push(id);
      assigned[id] = key;
    });

    (data.media || []).forEach(function (media, index) {
      var key = assigned[String(media.id)];
      if (key && featuredIndex[key] == null) featuredIndex[key] = index;
    });

    (data.media || []).forEach(function (media) {
      var id = String(media.id);
      if (assigned[id]) return;
      var hay = ((media.alt || '') + ' ' + (media.src || '')).toLowerCase();
      var hits = colors.filter(function (color) {
        var key = norm(color);
        return key && new RegExp('(?:^|[^a-z0-9])' + escapeRe(key) + '(?:[^a-z0-9]|$)').test(hay);
      });
      if (hits.length === 1) {
        var key = norm(hits[0]);
        groups[key].push(id);
        assigned[id] = key;
        altMatched = true;
      }
    });

    var featuredKeys = Object.keys(featuredIndex);
    var uniquePositions = {};
    var sequentialSafe = featuredKeys.length >= 2;
    featuredKeys.forEach(function (key) {
      var pos = featuredIndex[key];
      if (uniquePositions[pos] != null) sequentialSafe = false;
      uniquePositions[pos] = key;
    });

    if (sequentialSafe) {
      var sorted = featuredKeys.slice().sort(function (a, b) {
        return featuredIndex[a] - featuredIndex[b];
      });
      (data.media || []).forEach(function (media, index) {
        var id = String(media.id);
        if (assigned[id]) return;
        var owner = null;
        for (var i = 0; i < sorted.length; i++) {
          if (index >= featuredIndex[sorted[i]]) owner = sorted[i];
        }
        if (!owner) return;
        groups[owner].push(id);
        assigned[id] = owner;
      });
    }

    var leftover = (data.media || []).filter(function (media) {
      return !assigned[String(media.id)];
    });
    var extrasBeyondFeatured = featuredKeys.some(function (key) {
      return groups[key].length > 1;
    });

    if (leftover.length > 0 && !sequentialSafe && !altMatched && !extrasBeyondFeatured) {
      return null;
    }

    Object.keys(groups).forEach(function (key) {
      groups[key] = uniqueIds(groups[key]);
    });

    return groups;
  }

  function mediaIdFromSlide(el, sectionId) {
    if (!el) return '';
    var raw = el.getAttribute('data-media-id') || el.getAttribute('data-target') || '';
    var prefix = sectionId ? String(sectionId) + '-' : '';
    if (prefix && raw.indexOf(prefix) === 0) return raw.slice(prefix.length);
    return String(raw);
  }

  function sortByMediaOrder(list, items) {
    items
      .slice()
      .sort(function (a, b) {
        var ao = parseInt(a.getAttribute('data-gf-media-order'), 10);
        var bo = parseInt(b.getAttribute('data-gf-media-order'), 10);
        if (isNaN(ao) || isNaN(bo)) return 0;
        return ao - bo;
      })
      .forEach(function (item) {
        list.appendChild(item);
      });
  }

  function setHidden(el, hide) {
    if (!el) return;
    el.classList.toggle(HIDDEN, hide);
    if (hide) el.setAttribute('hidden', '');
    else el.removeAttribute('hidden');
  }

  function filterCollection(items, allowed, sectionId) {
    items.forEach(function (el) {
      var id = mediaIdFromSlide(el, sectionId);
      var hide = allowed ? allowed.indexOf(id) === -1 : false;
      setHidden(el, hide);
    });
  }

  function firstAllowedId(data, allowed, preferredId) {
    if (preferredId && allowed.indexOf(String(preferredId)) !== -1) return String(preferredId);
    var ordered = (data.media || []).map(function (media) {
      return String(media.id);
    });
    for (var i = 0; i < ordered.length; i++) {
      if (allowed.indexOf(ordered[i]) !== -1) return ordered[i];
    }
    return allowed[0] || '';
  }

  function applyFilter(gallery, colorValue, preferredMediaId) {
    var data = gallery._gfColorGalleryData;
    if (!data || !data.groups) return;

    var viewerList = gallery.querySelector('.product__media-list');
    var thumbList = gallery.querySelector('.thumbnail-list');
    var modal = document.getElementById('ProductModal-' + data.sectionId);
    var slides = viewerList ? Array.from(viewerList.querySelectorAll('[data-media-id]')) : [];
    var thumbs = thumbList ? Array.from(thumbList.querySelectorAll('[data-target]')) : [];
    var modalItems = modal
      ? Array.from(modal.querySelectorAll('.product-media-modal__content [data-media-id]'))
      : [];

    if (viewerList) sortByMediaOrder(viewerList, slides);
    if (thumbList) sortByMediaOrder(thumbList, thumbs);

    var colorKey = norm(colorValue);
    var allowed = colorKey ? data.groups[colorKey] : null;
    if (colorKey && (!allowed || !allowed.length)) {
      allowed = null;
    }

    filterCollection(slides, allowed, data.sectionId);
    filterCollection(thumbs, allowed, data.sectionId);
    filterCollection(modalItems, allowed, '');

    var visibleSlides = slides.filter(function (slide) {
      return !slide.classList.contains(HIDDEN);
    });
    if (!visibleSlides.length) {
      filterCollection(slides, null, data.sectionId);
      filterCollection(thumbs, null, data.sectionId);
      filterCollection(modalItems, null, '');
      visibleSlides = slides;
    }

    var activeId = allowed ? firstAllowedId(data, allowed, preferredMediaId) : '';
    var galleryMediaId = activeId ? data.sectionId + '-' + activeId : '';
    if (galleryMediaId && typeof gallery.setActiveMedia === 'function') {
      gallery.setActiveMedia(galleryMediaId, false);
    } else if (visibleSlides[0]) {
      slides.forEach(function (slide) {
        slide.classList.toggle('is-active', slide === visibleSlides[0]);
      });
    }

    if (viewerList) viewerList.scrollLeft = 0;

    if (typeof window.gfRefreshProductGallery === 'function') {
      window.gfRefreshProductGallery(gallery);
    } else {
      var viewer = gallery.querySelector('[id^="GalleryViewer-"]');
      if (viewer && typeof viewer.resetPages === 'function') viewer.resetPages();
    }
  }

  function selectedColorValue(root) {
    var checked = (root || document).querySelector(
      '.gf-color-size__group--color input[type="radio"]:checked'
    );
    return checked ? checked.value : '';
  }

  function galleriesIn(scope) {
    return Array.from((scope || document).querySelectorAll('media-gallery'));
  }

  function initGallery(gallery) {
    if (gallery._gfColorGalleryReady) return;
    var payload = readPayload(gallery);
    if (!payload) return;
    var groups = buildGroups(payload);
    if (!groups) return;
    gallery._gfColorGalleryReady = true;
    gallery._gfColorGalleryData = {
      sectionId: payload.sectionId || (gallery.id || '').replace('MediaGallery-', ''),
      media: payload.media || [],
      groups: groups,
    };
  }

  function applyToScope(scope, colorValue, preferredMediaId) {
    galleriesIn(scope).forEach(function (gallery) {
      initGallery(gallery);
      if (!gallery._gfColorGalleryData) return;
      applyFilter(gallery, colorValue, preferredMediaId);
    });
  }

  function isColorInput(input) {
    if (!input || input.type !== 'radio') return false;
    if (input.closest('.gf-color-size__group--color')) return true;
    var name = String(input.name || '').toLowerCase();
    return name.indexOf('color') !== -1 || name.indexOf('colour') !== -1 || name.indexOf('shade') !== -1;
  }

  document.addEventListener('change', function (event) {
    if (!isColorInput(event.target)) return;
    userSelectedColor = true;
    lastColorKey = norm(event.target.value);
    applyToScope(event.target.closest('product-info') || document, event.target.value);
  });

  function onVariantChange(event) {
    if (!userSelectedColor) return;
    var detail = event && event.data ? event.data : {};
    var htmlRoot = detail.html;
    var variant = detail.variant;
    var colorValue = selectedColorValue(document);
    if (!colorValue && lastColorKey) colorValue = lastColorKey;
    var preferred = variant && variant.featured_media ? variant.featured_media.id : '';
    applyToScope(document, colorValue, preferred);
    if (htmlRoot) return;
  }

  if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
    subscribe(PUB_SUB_EVENTS.variantChange, onVariantChange);
  }

  function boot() {
    galleriesIn(document).forEach(initGallery);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (event) {
    galleriesIn(event.target).forEach(initGallery);
    if (userSelectedColor) {
      applyToScope(event.target, selectedColorValue(event.target) || lastColorKey);
    }
  });
})();
